import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { Typography, Fade, makeStyles } from '@material-ui/core';
import Tag from '../../../tag';
import Agenda from '../agenda';
import { isArrayEmpty } from '../../../../../utility/helpers';
import {
  prepareUserAgenda,
  prepareModeratorAgenda,
} from '../../../../../utility/oneOnOne';
import { ellipsis } from '../../../../../constants/helperCssRules';

const VISIBLE_TAGS = 3;

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    boxSizing: 'border-box',
    borderRight: `1px dotted ${primary.bluish6}`,
    padding: spacing(6),
  },
  contentWrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridColumnGap: 16,
    gridRowGap: 24,
  },
  note: {
    color: primary.bluish3,
    marginBottom: spacing(1),
  },
  label: {
    color: primary.bluish3,
    marginBottom: spacing(1),
  },
  overflow: {
    ...ellipsis(),
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    whiteSpace: 'normal',
  },
  tagsWrapper: {
    gridColumn: 'span 2',
  },
  tagsList: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    minHeight: 28,
    width: '100%',
  },
  tag: {
    margin: spacing(0, 2, 2, 0),
  },
  tagsListWrapperMini: {
    minHeight: 28,
    gridColumn: 'span 3',
  },
  tagsListMini: {
    gridTemplateColumns: `repeat(${VISIBLE_TAGS}, minmax(0,min-content)) minmax(auto, min-content)`,
    gridColumnGap: spacing(2),
  },
}));

const Content = ({ translations, record }) => {
  const classes = useStyles();
  const { tags } = record;
  const userAgenda = prepareUserAgenda(record);
  const moderatorAgenda = prepareModeratorAgenda(record);

  return (
    <div className={classes.root}>
      <div className={classes.contentWrapper}>
        <Agenda
          translations={translations}
          moderatorAgenda={moderatorAgenda}
          employeeAgenda={userAgenda}
        />
        <div className={classes.tagsWrapper}>
          <Typography className={classes.label} variant="subtitle2">
            {translations.tags}
          </Typography>
          {!isArrayEmpty(tags) ? (
            <TransitionGroup className={classes.tagsList}>
              {tags.map(tag => (
                <Fade key={`tag_item_${tag.id}`} in>
                  <div className={classes.tag}>
                    <Tag tag={tag} color={tag.category.color} isSelected />
                  </div>
                </Fade>
              ))}
            </TransitionGroup>
          ) : (
            <div className={classes.tagsList}>-</div>
          )}
        </div>
      </div>
    </div>
  );
};

Content.propTypes = {
  translations: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired,
};

export default Content;
